import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useCustomToast } from 'design-system';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { useGetCategoriesApi } from './use-get-categories-api';

const endpoint = 'api/v1/cms/catalog-categories';
export const deleteCategoryEndpointIdentifier = endpoint;

type TData = Record<string, any>;
type TError = AxiosError;

type TVariables = {
  categoryId: number;
};

type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useDeleteCategoryApi(options?: Options): ReturnType {
  const { refetch: refetchCategories } = useGetCategoriesApi({ enabled: false });
  const toast = useCustomToast();

  const mutationFn = async ({ categoryId }: TVariables) => {
    try {
      const { data } = await http.delete(endpoint + `/${categoryId}`);

      // Refetch categories list
      refetchCategories();

      toast({
        description: 'Category has been deleted successfully',
        status: 'success',
      });

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: endpoint, ...options });
}
